import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) output[i] = rawData.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  if (!pushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

async function getOrRegisterSW() {
  const existing = await navigator.serviceWorker.getRegistration("/sw.js");
  if (existing) return existing;
  return navigator.serviceWorker.register("/sw.js");
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/sw.js");
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Notifiche push non supportate dal browser");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso notifiche negato");

  const reg = await getOrRegisterSW();
  await navigator.serviceWorker.ready;

  const { data: keyData } = await api.get("/push/public-key");
  if (!keyData.public_key) throw new Error("Chiave pubblica non disponibile");

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(keyData.public_key),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  const subJson = sub.toJSON();
  try {
    await api.post("/push/unsubscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
  } catch (e) {
    /* ignore */
  }
  await sub.unsubscribe();
}

export async function sendTestPush() {
  await api.post("/push/test");
}
